import type { ScreenSpaceFlags } from '@post-office/placement-common/pipes';
import {
	createClientPipeline,
	createServerPipeline,
} from '@post-office/placement-common/utils/create-pipeline'; // NOTE: TEMPORARY FIX You must add this yourself

import { type MessageTemplateContext } from '../../..';

export type HydrationResult = {
	status: string;
	planet: string;
};

type Pipe = ScreenSpaceFlags<{
	messageContext: MessageTemplateContext;
	hydrationResult: HydrationResult;
}>;

export const { createRender, createValidate } = createClientPipeline<Pipe>();
export const { createHydrate, createHydrateExample, createTransformMetadata } =
	createServerPipeline<Pipe>();
